// src/components/Footer.js
import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/custom.css'; // Importa tus estilos personalizados

const Footer = ({dvstyle}) => {
    //console.info(dvstyle);
    return (
        
        <footer className="footer-custom text-center" style={dvstyle}>
            <Container>
<div class="copyright text-center wow fadeIn" style={{visibility:'visible',animationname:'fadeIn'}}>
		<div class="text-center" style={{"display":"flex","justifyContent":"center","alignItems":"center","marginBottom":"10px"}}>
			<img style={{maxWidth: '250px'}} decoding="async" src="https://storage.mlcdn.com/account_image/757227/BcoOMtB856iu9KAX_grupoLPG_small_white-full.png" title="" alt="" loading="lazy" />															
		</div>
                            <p>Derechos Reservados © 2025, Dutriz Hermanos, S.A. de C.V.</p>
        <p>El uso de este sitio implica la aceptación de las condiciones generales de uso</p>
        <p><a href="https://hagamoscuentas.sv/politicas-de-privacidad/">Políticas de privacidad</a> | Términos y condiciones | <a href="https://docs.google.com/forms/d/e/1FAIpQLSe8-iWssk2bcA_sKnqGsh495iZaRS2dXAfPkwcqjeMQsnumTw/viewform">Contacto</a></p>				
	</div>                
                <p>&copy; {new Date().getFullYear()} Calculadora de Indemnización. Todos los derechos reservados.</p>
            </Container>
        </footer>
    );
};

export default Footer;